import { DEFAULT_EXPERIENCES_VALUE } from '@shared/models/experience-filter';

import { CandidatesConfig } from './candidates.abstract.config';

export const candidatesConfig: CandidatesConfig = {
  privileges: {
    assigned: {
      // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: 'web:assigned-candidates',
      jobs: 'web:assigned-jobs',
    },
    associate: {
      candidate_to_job: 'web:associate-candidate-to-job',
      jobs_to_candidate: 'web:associate-jobs-to-candidate',
    },
    candidates: {
      view: 'web:candiadtes-view',
      create: 'web:candiadtes-create',
      edit: 'web:candiadtes-edit',
      notes: 'web:candiadtes-notes',
      resumes: 'web:candiadtes-resumes',
      files: 'web:candiadtes-files',
      filesReadOnly: 'web:candidates-files:read-only',
      badges: 'web:candidates-badges',
      fullBadges: 'web:candidates-badges-full',
      inviteToApply: 'web:candidates-invite-to-apply',
    },
  },
  filter: {
    experience: DEFAULT_EXPERIENCES_VALUE,
  },
};
